import { Factory } from 'fishery';
import { Commodity } from '@trukt/types/Commodity';

export const commodityFactory = Factory.define<Commodity>(({ sequence }) => ({
  guid: sequence.toString(),
  damaged: false,
  operable: true,
  inoperable: 'yes',
  description: '2724 Fiat Prius',
  identifier: sequence.toString(),
  identifierQualifier: 'VIN',
  lotNumber: '12345678',
  referenceNumber: '12345678',
  dateStarted: '2022-01-01T00:00:00.000Z',
  dateCompleted: '2022-01-01T00:00:00.000Z',
  type: 'vehicle',
  status: 'Test Status',
  length: 10,
  height: 10,
  width: 10,
  weight: 10,
  quantity: 10,
  capacity: 10,
  vehicle: {
    id: sequence.toString(),
    year: '2022',
    make: 'Chevrolet',
    model: 'Camry',
    trim: 'Test Trim',
    bodyType: 'SUV',
    weightClass: '2',
  },
  year: '2724',
  make: 'Fiat',
  model: 'Prius',
  deliveryStatus: 'none',
  trim: '',
  typeId: 1,
  name: 'Chevrolet Camry',
  category: 'vehicle',
}));
